/**
 * The user's Programs grant (`userPermissions.enablePrograms`) only
 * has effect on an account with the Programs module on, and the
 * account-access PATCH refuses it elsewhere (422). On an account
 * without the module the grant is left exactly as stored: the form
 * does not offer the row there, and a bulk save applying one
 * permission set to several accounts must not send it either, which
 * is what the API itself does on the create / add-accounts paths.
 *
 * `account` is a `userAccounts[]` entry: `accountEnablePrograms` is
 * the account's switch, `userPermissions` what is stored today.
 */
export const withProgramsGrantWhereModuleOn = (formValues, account) => {
  if (account?.accountEnablePrograms || !formValues?.userPermissions) return formValues;
  return {
    ...formValues,
    userPermissions: {
      ...formValues.userPermissions,
      enablePrograms: !!account?.userPermissions?.enablePrograms,
    },
  };
};
